import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RowActionComponent } from './row-action/row-action.component';

@NgModule({
  declarations: [RowActionComponent],
  imports: [CommonModule],
  exports: [RowActionComponent],
})
export class TablesModule {}
